<ion-header class="ion-no-border">
  @let stopData = nextStop();
  @let freightDetailData = freightDetail();
  @let stopDetailData = nextStop();
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        attr.aria-label="{{ 'general.cancel' | translate }}"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'freight.detail.stop_departure' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (isLoading() || !stopData) {
    <lib-spinner-loading></lib-spinner-loading>
  } @else {
    <ion-grid class="ion-no-padding">
      <ion-row class="padding-bottom">
        <ion-col
          size="12"
          [sizeLg]="6"
        >
          <div
            class="step step--active"
            [class.step--to-load]="stopData.type === EStopType.LOAD"
            [class.step--to-unload]="stopData.type === EStopType.UNLOAD"
            [class.step--to-unload_load]="stopData.type === EStopType.UNLOAD_LOAD"
          >
            @if (stopData.type === EStopType.LOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/upload_24dp.svg"
              ></ion-icon>
            } @else if (stopData.type === EStopType.UNLOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/download_24dp.svg"
              ></ion-icon>
            } @else if (stopData.type === EStopType.UNLOAD_LOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/swap_vert_24dp.svg"
              ></ion-icon>
            }
            <div>
              <div class="step-type">
                @if (stopData.type === EStopType.LOAD) {
                  {{ 'tasks.load' | translate }}:
                } @else if (stopData.type === EStopType.UNLOAD) {
                  {{ 'tasks.unload' | translate }}:
                } @else if (stopData.type === EStopType.UNLOAD_LOAD) {
                  {{ 'tasks.unload_load' | translate }}:
                }
                <span>
                  ({{ stopData.address?.countryCode }})
                  {{ stopData.address?.postalCode }}
                  @if (stopData.address?.countryCode && stopData.address?.stateCode) {
                    {{
                      `states.${stopData.address?.countryCode ?? ''}${stopData.address?.stateCode ?? ''}` | translate
                    }}
                  }
                </span>
              </div>
              <lib-freight-carrier-inprogress-card-address
                [address]="stopData.address"
              ></lib-freight-carrier-inprogress-card-address>
            </div>
          </div>
        </ion-col>
        <ion-col
          size="12"
          [sizeLg]="6"
        >
          <lib-freight-carrier-inprogress-card-schedule
            [since]="stopData.since"
            [until]="stopData.until"
          ></lib-freight-carrier-inprogress-card-schedule>
        </ion-col>
      </ion-row>

      <ion-row>
        @if (freightDetailData.instructions !== undefined && freightDetailData.observations !== undefined) {
          <ion-col size="12">
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/info_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                @if (freightDetailData.instructions !== undefined) {
                  <p>{{ freightDetailData.instructions }}</p>
                }
                @if (freightDetailData.observations !== undefined) {
                  <p>{{ freightDetailData.observations }}</p>
                }
              </div>
            </div>
          </ion-col>
        }
        @if (stopDetailData && stopDetailData.reference !== undefined) {
          <ion-col
            size="12"
            [sizeLg]="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/barcode_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.stop_reference' | translate }}</p>
                <p>{{ stopDetailData.reference }}</p>
              </div>
            </div>
          </ion-col>
        }
        @if (stopDetailData && stopDetailData.instructions !== undefined && stopDetailData.instructions !== '') {
          <ion-col
            size="12"
            [sizeLg]="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/comment_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                <p>{{ stopDetailData.instructions }}</p>
              </div>
            </div>
          </ion-col>
        }
        @if (freightDetailData.vehicles.length > 0) {
          <ion-col
            size="12"
            [sizeLg]="6"
          >
            <div class="freight-data-block">
              <ion-icon
                aria-hidden="true"
                src="../assets/material-symbols/local_shipping_24dp.svg"
              ></ion-icon>
              <div>
                <p class="subtitle">{{ 'freight.detail.asigned_vehicle' | translate }}</p>
                @for (vehicle of freightDetailData.vehicles; track vehicle.id) {
                  <p>
                    <span class="plate">{{ vehicle.plate }}</span>
                    @if (vehicle.type) {
                      {{ 'vehicleType.' + vehicle.type | translate }}
                    }
                  </p>
                }
              </div>
            </div>
          </ion-col>
        }
      </ion-row>

      <ion-row>
        <ion-col>
          <div class="freight-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/where_to_vote_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">{{ 'freight.detail.coords_app' | translate }}</p>

              <lib-freight-carrier-stop-geolocation
                (coordsChange)="onCoordsChange($event)"
              ></lib-freight-carrier-stop-geolocation>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <form [formGroup]="finishedStopDataForm">
        @if (stopData.type === 'UNLOAD' || stopData.type === 'UNLOAD_LOAD') {
          <ion-row>
            <ion-col>
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/download_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.title_form_unload' | translate }}</p>
                  <p class="fs-sm">
                    {{ 'freight.detail.review_form' | translate }}
                  </p>
                </div>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="margin-top-middle">
            <ion-col
              size="6"
              class=""
            >
              <ion-input
                type="number"
                label="* {{ 'freight.detail.unloaded_weight' | translate }}"
                name="unloadedWeight"
                formControlName="unloadedWeight"
                placeholder="{{ 'freight.detail.unloaded_weight' | translate }}"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
            <ion-col
              size="6"
              class="ion-padding-start"
            >
              <ion-input
                type="number"
                label=" * {{ 'freight.detail.unloaded_packages' | translate }}"
                name="unloadedPackages"
                formControlName="unloadedPackages"
                placeholder="{{ 'freight.detail.unloaded_packages' | translate }}"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col
              size="12"
              class=""
            >
              <ion-input
                type="text"
                label="{{ 'freight.detail.reservations' | translate }}"
                name="reservations"
                formControlName="reservations"
                placeholder="{{ 'freight.detail.reservations' | translate }}"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
          </ion-row>
        }
        @if (stopData.type === 'LOAD' || stopData.type === 'UNLOAD_LOAD') {
          <ion-row>
            <ion-col>
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/upload_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.title_form_load' | translate }}</p>
                  <p class="fs-sm">
                    {{ 'freight.detail.review_form' | translate }}
                  </p>
                </div>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="margin-top-middle">
            <ion-col
              size="6"
              class="padding-end"
            >
              <ion-input
                type="number"
                label="* {{ 'freight.detail.loaded_weight' | translate }}"
                name="loadedWeight"
                formControlName="loadedWeight"
                placeholder="{{ 'freight.detail.loaded_weight' | translate }}"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
            <ion-col
              size="6"
              class="padding-start"
            >
              <ion-input
                type="number"
                label=" * {{ 'freight.detail.loaded_packages' | translate }}"
                name="loadedPackages"
                formControlName="loadedPackages"
                placeholder="{{ 'freight.detail.loaded_packages' | translate }}"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <ion-input
                type="text"
                label="* {{ 'freight.detail.nature_load_description' | translate }}"
                name="loadedNature"
                formControlName="loadedNature"
                placeholder="{{ 'freight.detail.nature_load_description' | translate }}"
                autocapitalize="characters"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
          </ion-row>
          @if (stopData.type === 'LOAD') {
            <ion-row>
              <ion-col size="12">
                <ion-input
                  type="text"
                  label="{{ 'freight.detail.reservations' | translate }}"
                  name="reservations"
                  formControlName="reservations"
                  placeholder="{{ 'freight.detail.reservations' | translate }}"
                  autocapitalize="characters"
                  labelPlacement="floating"
                  fill="outline"
                  mode="md"
                ></ion-input>
              </ion-col>
            </ion-row>
          }
          <ion-row>
            <ion-col size="12">
              <ion-input
                type="text"
                label="{{ 'freight.detail.seal_number' | translate }}"
                name="loadedSealNumber"
                formControlName="loadedSealNumber"
                placeholder="{{ 'freight.detail.seal_number' | translate }}"
                autocapitalize="characters"
                labelPlacement="floating"
                fill="outline"
                mode="md"
              ></ion-input>
            </ion-col>
          </ion-row>
        }
        <ion-row>
          <ion-col
            size="12"
            class="ion-no-padding"
          >
            <ion-button
              expand="block"
              fill="outline"
              type="button"
              id="sign"
            >
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/signature_24dp.svg"
              ></ion-icon>
              {{ 'freight.detail.signature' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>
      </form>

      <ion-row>
        <ion-col>
          <p
            class="fs-sm"
            [innerHTML]="'freight.detail.final_message_form' | translate"
          ></p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'freight.detail.confirm_departure' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
